import React from "react";
import PropTypes from "prop-types";
import DeleteDialog from "components/Elements/DeleteDialog";

const ModelTaskDeleteDialog = ({ taskId, taskCaption, deleteEndpoint, onClose, onDeleted }) => (
	<DeleteDialog
		entityName={taskCaption}
		open={taskId !== null}
		closeHandler={onClose}
		deleteEndpoint={deleteEndpoint}
		deleteID={taskId}
		handleRemoveData={onDeleted}
	/>
);

ModelTaskDeleteDialog.propTypes = {
	taskId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	taskCaption: PropTypes.string,
	deleteEndpoint: PropTypes.string.isRequired,
	onClose: PropTypes.func.isRequired,
	onDeleted: PropTypes.func.isRequired,
};

export default ModelTaskDeleteDialog;
